<script>
    import { markFile } from '@/api/file.js';


    export default {
        props: {
            file: Object,
        },
        computed: {
            additionalStatus() { return this.$store.getters.ADDITIONAL_STATUS },
            assetTypeID() { return this.$store.getters.ASSET_TYPE_IMAGES },
        },
        async mounted() {
            await this.loadBaseAdditionalStatus();
        },
        methods: {
            async loadBaseAdditionalStatus() {
                const adminTip = document.getElementById(`admin-tip-${this.file.id}`);
                adminTip.value = this.file.adminTip;
                const additionalStatus = document.getElementById(`additional-status-${this.file.id}`);
                additionalStatus.value = this.file.additionalStatus;
            },
            async mark() {
                const response = await markFile(this.assetTypeID, this.file);
                if (response === true) this.file.updateAdditionalFileData();
            },
            async changeAdminTip(event) {
                this.file.setAdminTip(event.target.value);
            },
            async changeAdditionalStatus(event) {
                this.file.setAdditionalStatus(event.target.value);
            }
        },
        watch: {
            file: {
                handler: async function() {
                    this.$nextTick(async () => {
                        await this.loadBaseAdditionalStatus();
                    });
                }
            }
        }
    }
</script>


<template>
    <div class="image_additional_status">
        <label>Additional Status:</label>
        <input 
            class="ml_5" 
            type="text"
            @change="changeAdminTip"
            :id="`admin-tip-${file.id}`"
        >
        <select 
            class="ml_5"
            @change="changeAdditionalStatus"
            :id="`additional-status-${file.id}`"
        >
            <option
                v-for="(additionalValue, additionalIndex) in additionalStatus" :key="additionalIndex"
                :value="additionalValue['id']"
            >
                {{ additionalValue['name'] }}
            </option>
        </select>
        <button 
            :disabled="file['isEditAdditional'] === false" 
            class="button_blue_150 ml_5"
            @click="mark"    
        >Save</button>
    </div>
</template>


<style scoped>
    .image_additional_status {
        display: flex;
        flex-direction: row;

        padding: 10px;
    }

    input {
        border-radius: 5px;
        border: var(--border);
        /* box-shadow: none; */
        width: 300px;
    }
    select {
        border: var(--border);
        border-radius: 5px;
    }
</style>